import React from 'react';
// import Swiper core and required modules
import SwiperCore, { Keyboard, Mousewheel } from "swiper/core";

import { Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Articles, { ArticlesHome } from './Articles';

SwiperCore.use([Keyboard, Mousewheel]);

export const ArticleSwiperHome = ({ spaceBetween, slidesPerView }) => {
    return (
        <Swiper
            modules={[Pagination, A11y]}
            spaceBetween={spaceBetween}
            slidesPerView={slidesPerView}
            pagination={{ clickable: true }}
            slideToClickedSlide={true}
            mousewheel={true}
            keyboard={true}
        >
            <SwiperSlide>
                <ArticlesHome
                    description={`Kardinal offers the best flexibility when it comes to business travel. It is Business travel with all the benefits of leisure travel.`}
                    title={`Chioma.`}
                    subTitle={`Nigerian Solidarity Fund`}
                />
            </SwiperSlide>
            <SwiperSlide>
                <ArticlesHome
                    description={`Kardinal has made our lives easier by providing easy-to-use reports, mobile responsiveness, and quick response times.`}
                    title={`Thompson.`}
                    subTitle={`Fidson Healthcare Limited`}
                />
            </SwiperSlide>
            <SwiperSlide>
                <ArticlesHome
                    description={`Doing travel has never been easier or faster. We never knew we needed this.`}
                    title={`Anthonia.`}
                    subTitle={`JNCI`}
                />
            </SwiperSlide>
            <SwiperSlide>
                <ArticlesHome
                    description={`We have had so much trouble reconciling travel expenses, but Kardinal gives us a simple solution to this problem.`}
                    title={`Desmond.`}
                    subTitle={`Chocolate City Music`}
                />
            </SwiperSlide>
        </Swiper>
    );
};

const ArticleSwiper = ({ spaceBetween, slidesPerView }) => {
    return (
        <Swiper
            modules={[Pagination, A11y]}
            spaceBetween={spaceBetween}
            slidesPerView={slidesPerView}
            pagination={{ clickable: true }}
            mousewheel={{sensitivity: 100, invert: false}}
            keyboard={true}
        >
            <SwiperSlide>
                <Articles
                    icon={require("../assets/travel/book_icon_travel.png")}
                    title="Book"
                    description="Book cheaply, easily, and securely with our AI-powered booking engine. Powered by our extensive car, flight, and hotel inventory."
                />
            </SwiperSlide>
            <SwiperSlide>
                <Articles
                    icon={require("../assets/travel/control_icon_travel.png")}
                    title="Full control"
                    description="You can schedule trips for your employees in 2 minutes, using our automated system, and spend more time on what matters."
                />
            </SwiperSlide>
            <SwiperSlide>
                <Articles
                    icon={require("../assets/travel/cost_icon_travel.png")}
                    title="Cost"
                    description="Save up to 35% when you access our negotiated rates, savings, and diverse flight and hotel inventory."
                />
            </SwiperSlide>
            <SwiperSlide>
                <Articles
                    icon={require("../assets/travel/manage_icon_travel.png")}
                    title="Manage"
                    description="Travel choices and spending can be controlled fully with our automated Travel Policy."
                />
            </SwiperSlide>
            <SwiperSlide>
                <Articles
                    icon={require("../assets/travel/track_icon_travel.png")}
                    title="Track"
                    description="No paperwork. With our real-time data reporting tools, you can stay on top of corporate travel performance."
                />
            </SwiperSlide>
        </Swiper>
    );
};

export default ArticleSwiper;